import React from 'react';

interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
  fullWidth?: boolean;
  variant?: 'primary' | 'secondary';
  size?: 'small' | 'medium' | 'large';
  disabled?: boolean;
  className?: string;
  href?: string;
  target?: string;
}

const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  type = 'button',
  fullWidth = false,
  variant = 'primary',
  size = 'medium',
  disabled = false,
  className = '',
  href,
  target
}) => {
  const baseClasses = 'rounded font-bold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-opacity-50 inline-flex items-center justify-center';
  
  const variantClasses = {
    primary: `bg-[#05f217] hover:bg-[#04d915] text-black focus:ring-[#05f217] ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`,
    secondary: `bg-white text-black border border-[#05f217] hover:bg-gray-50 focus:ring-[#05f217] ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`
  };
  
  const sizeClasses = {
    small: 'px-3 py-1.5 text-sm',
    medium: 'px-4 py-2.5',
    large: 'px-6 py-3 text-lg'
  };
  
  const widthClass = fullWidth ? 'w-full' : '';
  
  const combinedClasses = `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${widthClass} ${!disabled && 'hover:shadow-md active:translate-y-0.5'} ${className}`;
  
  // Se href for fornecido, renderiza como link
  if (href) {
    return (
      <a
        href={href}
        target={target}
        className={combinedClasses}
      >
        {children}
      </a>
    );
  }
  
  // Caso contrário, renderiza como botão
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={combinedClasses}
    >
      {children}
    </button>
  );
};

export default Button;